<template>
  <component
      v-for="modal in modals"
      :key="modal.id"
      :is="modal.component"
      v-bind="modal.props"
      @close="close(modal.props.id)"
  />
</template>
<script setup>
import {computed, inject} from "vue";

const controller = inject('modal');
const modals = computed(() => controller.all());

function close(id) {
  controller.close(id);
}
</script>